import { render } from "./ProfileSummary.vue?vue&type=template&id=1c98a71a&ts=true"
import script from "./ProfileSummary.vue?vue&type=script&lang=ts"
export * from "./ProfileSummary.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__